import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/lib/util/colors";
import store from "@/store";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: store.state.isDarkMode,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#1b428b",
        primaryDark: "#1c1d21",
        primaryGrey: "#a1c7e2",
        outline: "#e1eaf1",
        primaryOutline: "#1e8ecc",
        restingOutline: "#e4ecf2",
        background: "#c6ced4",
        backgroundLight: "#f5f5fa",
        backgroundWhite: "#ffffff",
        buttonHover: "#1c1d21",
        secondary: "#f7af5d",
        accent: "#e4592c",
        error: "#c63e12",
        info: "#1e8ecc",
        success: "#bbc492",
        warning: "#d99a52",
        border: "#d9d9d9",
        borderDark: "#183a7a",
        borderLight: "#979797",
        vtblue: "#0581c6",
        vtred: "#e14615",
        lightCoral: "#f08080",
        midnightBlue: "#325597",
        orangered: "#fe4503",
        lightYelow: "#f8b76d",
        yellow: "#f6a700",
        orange: "#ffa500",
        alarmBackground: "#FFC4C4",
        alarmText: "#FF0000",
        cautionBackground: "#FFE5B4",
        cautionText: "#FFA500",
        noIssuesBackground: "#C7F5C7",
        noIssuesText: "#008000",
        checkDeviceBackground: "#C6E2FF",
        checkDeviceText: "#0000FF",
        titleLight: "#03001C",
        L1: "#A0522D",
        L2: "#424242",
        L3: "#B0BEC5",
        brown: colors.brown.darken2,
        lightBlue: colors.blue.lighten1,
        lightRed: colors.red.lighten3,
        indigo: colors.indigo.darken3,
        darkGrey: colors.grey.darken4,
        lightGrey: colors.grey.lighten3,
      },
      dark: {
        primary: "#a1c7e2",
        primaryDark: "#A9A9A9",
        primaryGrey: "#a1c7e2",
        outline: "#e1eaf1",
        primaryOutline: "#1e8ecc",
        restingOutline: "#e4ecf2",
        background: "#1e1f23",
        backgroundLight: "#2a2c32",
        backgroundWhite: "#1c1d21",
        buttonHover: "#2a2c32",
        secondary: "#f7af5d",
        accent: "#e4592c",
        error: "#c63e12",
        info: "#1e8ecc",
        success: "#bbc492",
        warning: "#d99a52",
        border: "#d9d9d9",
        borderDark: "#979797",
        borderLight: "#555555",
        vtblue: "#0581c6",
        vtred: "#e14615",
        lightCoral: "#f08080",
        midnightBlue: "#325597",
        orangered: "#fe4503",
        lightYelow: "#f8b76d",
        yellow: "#f6a700",
        orange: "#ffa500",
        alarmBackground: "#5C0000",
        alarmText: "#FF0000",
        cautionBackground: "#6B3E07",
        cautionText: "#FFA500",
        noIssuesBackground: "#225522",
        noIssuesText: "#00FF00",
        checkDeviceBackground: "#225578",
        checkDeviceText: "#33A1DE",
        titleLight: "#E0E0E0",
        L1: "#8B4513",
        L2: "#616161",
        L3: "#9E9E9E",
        brown: colors.brown.lighten1,
        lightBlue: colors.blue.lighten1,
        lightRed: colors.red.lighten3,
        indigo: colors.indigo.darken3,
        darkGrey: colors.grey.darken4,
        lightGrey: colors.grey.lighten3,
      },
    },
  },
});
